/**
 * @generated SignedSource<<b5bcb508eb4de3bf7991b7791ba240fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreTier = "basic" | "free" | "light" | "premium" | "standard" | "unlimited";
export type UserSetStoreScreenQuery$variables = Record<PropertyKey, never>;
export type UserSetStoreScreenQuery$data = {
  readonly me: {
    readonly currentStoreId: string | null;
    readonly id: string;
    readonly stores: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly tier: StoreTier;
      readonly timezone: string;
    }>;
  };
  readonly store: {
    readonly id: string;
  };
};
export type UserSetStoreScreenQuery = {
  response: UserSetStoreScreenQuery$data;
  variables: UserSetStoreScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "me",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "stores",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStoreId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSetStoreScreenQuery",
    "selections": [
      (v1/*: any*/),
      {
        "kind": "RequiredField",
        "field": (v2/*: any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserSetStoreScreenQuery",
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "4586081127980ed2e388e05d512b8891",
    "id": null,
    "metadata": {},
    "name": "UserSetStoreScreenQuery",
    "operationKind": "query",
    "text": "query UserSetStoreScreenQuery {\n  store {\n    id\n  }\n  me {\n    id\n    stores {\n      id\n      name\n      tier\n      timezone\n    }\n    currentStoreId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e425691110e8a3ee9d768e2a37d0203a";

export default node;
